"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatComparison = void 0;
var formatComparison = function (comparison) {
    if (!comparison)
        return undefined;
    return {
        value: Math.abs(comparison.change_percent),
        direction: comparison.change_percent >= 0 ? "up" : "down",
    };
};
exports.formatComparison = formatComparison;
